const state = {
  loading: false,
};

const actions = {
  initCustomLoading({ commit }) {
    commit('setCustomLoading', true);
  },
  removeCustomLoading({ commit }) {
    commit('setCustomLoading', false);
  },
};

const mutations = {
  setCustomLoading(state, payload) {
    state.loading = payload;
  },
};

export default {
  state,
  actions,
  mutations,
};
